// extracted by mini-css-extract-plugin
export default {"container":"burger-price_container__z9IHH","price":"burger-price_price__KQV4h"};